export const colors = [
  { color: "#0a2472", active: false },
  { color: "#d7bb4f", active: false },
  { color: "#282828", active: false },
  { color: "#b1d6e8", active: false },
  { color: "#9c7539", active: false },
  { color: "#d29b48", active: false },
  { color: "#e6ae95", active: false },
  { color: "#d76b67", active: false },
  { color: "#bababa", active: true },
  { color: "#bfdcc4", active: false },
];
export const categories = [
  "Dresses",
  "Shorts",
  "Sweatshirts",
  "Swimwear",
  "Jackets",
  "T-Shirts & Tops",
  "Jeans",
  "Trousers",
  "Men",
  "Jumpers & Cardigans",
];

export const sizes = ["XS", "S", "M", "L", "XL", "XXL"];

export const brands = [
  { name: "Adidas", count: 2 },
  { name: "Balmain", count: 7 },
  { name: "Balenciaga", count: 10 },
  { name: "Burberry", count: 39 },
  { name: "Kenzo", count: 95 },
  { name: "Givenchy", count: 1092 },
  { name: "Zara", count: 48 },
];

export const filters = [
  { id: 1, label: "Blues" },
  { id: 2, label: "Max Price: $493" },
  { id: 3, label: "Zara" },
];
